/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */

import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { InventoryCountEntryBase } from 'shared/dbo/InventoryCountEntry';

export interface InventoryCountEntryIndexedDb {
	id: string;
	inventoryCountId: string;
	consumableId: string;
	quantity?: number;
	measurementUnitId?: string;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isInventoryCountEntryIndexedDb = (obj: unknown): obj is InventoryCountEntryIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ inventoryCountId: unknown }>(obj, 'inventoryCountId') || !(typeof obj.inventoryCountId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ consumableId: unknown }>(obj, 'consumableId') || !(typeof obj.consumableId === 'string')) {
		return false;
	}
	if (hasPropOfType<{ quantity: unknown }>(obj, 'quantity') && !(typeof obj.quantity === 'number')) {
		return false;
	}
	if (hasPropOfType<{ measurementUnitId: unknown }>(obj, 'measurementUnitId') && !(typeof obj.measurementUnitId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: InventoryCountEntryBase): InventoryCountEntryIndexedDb => ({
	id: obj.id.toString(),
	inventoryCountId: obj.inventoryCountId.toString(),
	consumableId: obj.consumableId.toString(),
	quantity: obj.quantity ?? undefined,
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	measurementUnitId: obj.measurementUnitId == null ? undefined : obj.measurementUnitId.toString(),
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: InventoryCountEntryIndexedDb): InventoryCountEntryBase => ({
	id: UUID.fromString(obj.id),
	inventoryCountId: UUID.fromString(obj.inventoryCountId),
	consumableId: UUID.fromString(obj.consumableId),
	quantity: obj.quantity,
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	measurementUnitId: obj.measurementUnitId == null ? undefined : UUID.fromString(obj.measurementUnitId),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdInventoryCountEntry: LocalDatabaseTableDefinition<InventoryCountEntryBase, InventoryCountEntryIndexedDb> = {
	tableName: 'inventoryCountEntries',
	indexColumns: ['inventoryCountId', 'consumableId'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
